import { IconButton, Tooltip, Box, Typography } from '@mui/material'
import { Language } from '@mui/icons-material'
import { useUIStore } from '@store/uiStore'

/**
 * Language Switcher Component - Instant Toggle
 */
const LanguageSwitcher = ({ sx = {} }) => {
    const { language, setLanguage } = useUIStore()

    const handleToggle = () => {
        // Instantly swap between Arabic and English
        setLanguage(language === 'ar' ? 'en' : 'ar')
    }

    return (
        <Tooltip title={language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}>
            <IconButton
                onClick={handleToggle}
                size="small"
                sx={{
                    ml: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    borderRadius: 2,
                    px: 1,
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                    '&:hover': {
                        bgcolor: 'rgba(255, 255, 255, 0.2)',
                    },
                    ...sx
                }}
            >
                <Language fontSize="small" />
                <Typography variant="caption" fontWeight={600}>
                    {language === 'ar' ? 'EN' : 'عربي'}
                </Typography>
            </IconButton>
        </Tooltip>
    )
}

export default LanguageSwitcher

